export const HomeResourcesDA = {
  heroTitle: "Aida Bikic",
  heroNameTitle: "Psykolog, forsker og foredragsholder",
  heroSubtitle:
    "Forstå hvordan skærme påvirker opmærksomhed og trivsel for børn og unge",
  heroDescription: "Sunde digitale rammer for børn og unges trivsel",
  heroExpertise: "Viden og redskaber om ADHD i den digitale tidsalder",
  cta: "Læs mere",
  s1Title: "Forældre & trivsel",
  s1Text: "Viden og værktøjer til hverdagen med skærme og sociale medier.",
  s2Title: "Skoler & læring",
  s2Text: "Foredrag og forløb om opmærksomhed, læring og digital dannelse.",
  s3Title: "Forskning & medier",
  s3Text: "Formidling af viden om teknologiens påvirkning af børns hjerner.",
  videosTitle: "Dokumentarfilm",
  videosIntro: "Se Aida i forskellige medier og interviews",
  podcastsTitle: "Podcasts",
  podcastsIntro: "Lyt til Aida i podcasts om børn, teknologi og læring",

  // Video links
  video1Title: "NDR Panorama 3",
  video1Description: "Interview om skærmbrug og børn",
  video1Url:
    "https://www.ndr.de/fernsehen/sendungen/panorama3/Panorama-3,sendung1549306.html",

  video2Title: "SRF Puls",
  video2Description:
    "Glücksfresser Smartphone - Helfen Jugendlichen nur noch Verbote?",
  video2Url:
    "https://www.srf.ch/play/tv/puls/video/gluecksfresser-smartphone---helfen-jugendlichen-nur-noch-verbote?urn=urn:srf:video:718034d7-11d4-4736-abad-358e32ee2328",

  video3Title: "YouTube Interview 1",
  video3Description: "Interview om teknologi og børns udvikling",
  video3Url: "https://www.youtube.com/watch?v=hcYaQf9NnI8",

  video4Title: "YouTube Interview 2",
  video4Description: "Interview om skærmtid og ADHD",
  video4Url: "https://www.youtube.com/watch?v=vH6_xXifMSc",

  video5Title: "CyberSundhed - Boundaries give children security",
  video5Description: "Digital sundhed og børn",
  video5Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  video6Title:
    "BH Futures Foundation – Koncentration og fokus i den digitale tidsalder",
  video6Description: "Koncentration og fokus i den digitale tidsalder",
  video6Url: "https://www.youtube.com/watch?v=oO9pr9MOzXY",

  video7Title: "TV2 Fyn",
  video7Description: "Skærmforsker er urokkelig, når hans datter græder",
  video7Url: "https://www.facebook.com/watch/?v=1261850819059739",

  video8Title: "Go' morgen Danmark & Go' aften Live",
  video8Description: "Skærmtid røver børn for deres kreativitet",
  video8Url: "https://www.facebook.com/watch/?v=1159225205443624",

  video9Title: "Headspace",
  video9Description: "Digitale forældrestrategier",
  video9Url: "https://www.facebook.com/watch/?v=1064828598575157",

  video10Title: "Headspace",
  video10Description: "Skærmtidsretningslinjer for familier",
  video10Url: "https://www.facebook.com/watch/?v=1092654535612773",

  video11Title: "BHRT Radiotelevizija Bosne I Hercegovine",
  video11Description: "Digital afrusning",
  video11Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  video12Title: "FACE HD TV",
  video12Description: "Koncentration i den digitale tidsalder",
  video12Url: "https://www.youtube.com/watch?v=52YMLkfUQvQ",

  video13Title: "ALFA TV HD",
  video13Description: "Forældreskab i den digitale verden",
  video13Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY",

  video14Title: "PSYCHOLOGOS Podcast",
  video14Description: "Børns mentale sundhed og skærme",
  video14Url: "https://www.youtube.com/watch?v=OZd7SrqAwhY",

  video15Title: "Zonen (7 dage uden sociale medier ændrede mit liv)",
  video15Description: "Digital læsning for familier",
  video15Url: "https://www.youtube.com/watch?v=tXfJsYRKeR4",

  video16Title: "WDR Local Time",
  video16Description: "Børn og deres digitale verden",
  video16Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/kinder-und-ihre-digitale-welt-100.html",

  video17Title: "TV2 News",
  video17Description: "Skærmtidsforskningsresultater",
  video17Url: "https://www.youtube.com/watch?v=9Bm7BjFYL4Q",

  video18Title: "DR Ultra",
  video18Description: "Teknologi og børns udvikling",
  video18Url: "https://www.youtube.com/watch?v=mF08O2mL7zY",

  video19Title: "TV2 Fyn",
  video19Description: "Mobilfri når skærmen går i sort",
  video19Url:
    "https://play.tv2.dk/serie/mobilfri-naar-skaermen-gaar-i-sort-tv2fyn",

  video20Title: "DR Ultra",
  video20Description: "Fake eller fakta - kaniner hopper på trampolin",
  video20Url:
    "https://www.dr.dk/drtv/se/ultra-nyt_-fake-eller-fakta_-kaniner-hopper-paa-trampolin_533209",

  // Podcast translations
  podcast1Title: "Ser du for meget skærm?",
  podcast1Description: "Kraniebrud podcast om skærmbrug",
  podcast1Url: "https://radio4.dk/podcasts/kraniebrud/ser-du-for-meget-sk-rm",

  podcast2Title: "Spotify Podcast",
  podcast2Description:
    "Spirende Sind: En Børne- og ungdomsppsykiatrisk podcast",
  podcast2Url: "https://open.spotify.com/episode/7stFudvRMPXrW5clAcxCYm",

  podcast3Title: "CyberSundhed",
  podcast3Description: "Aida Bikic på CyberSundhed podcast",
  podcast3Url:
    "https://creators.spotify.com/pod/profile/cybersundhed/episodes/--Aida-Bikic--CyberSundhed-e2k6mev",

  podcast4Title: "YouTube Interview",
  podcast4Description: "Digital sundhed og børn",
  podcast4Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  podcast5Title: "Spotify Episode",
  podcast5Description: "Interview med Signe",
  podcast5Url: "https://open.spotify.com/episode/0uTamNr0fQvP7aygp4zyTz",

  podcast6Title: "Brainstorm Podcast",
  podcast6Description: "Hvorfor har jeg så svært ved at lægge min mobil væk?",
  podcast6Url:
    "https://podcasts.apple.com/ga/podcast/hvorfor-har-jeg-s%C3%A5-sv%C3%A6rt-ved-at-l%C3%A6gge-min-mobil-v%C3%A6k/id1449966468?i=1000671757018",

  watchButton: "Se video",
  learnMoreButton: "Læs mere",
};

export const HomeResourcesEN = {
  heroTitle: "Aida Bikic",
  heroNameTitle: "Psychologist, Researcher, and Speaker",
  heroSubtitle:
    "Understanding how screens affect attention and \nwell-being in children and youth",
  heroDescription:
    "Creating healthy digital spaces for kid's and teens' well-being",
  heroExpertise: "Knowledge and tools for ADHD in the digital age",
  cta: "Read more",
  s1Title: "Parents & Well-being",
  s1Text:
    "Knowledge and tools for everyday life with screens and social media.",
  s2Title: "Schools & Learning",
  s2Text: "Lectures and courses on attention, learning, and digital literacy.",
  s3Title: "Research & Media",
  s3Text:
    "Dissemination of knowledge about technology's impact on children's brains.",
  videosTitle: "Documentaries",
  videosIntro: "Watch Aida in various media and interviews",
  podcastsTitle: "Podcasts",
  podcastsIntro:
    "Listen to Aida in podcasts about children, technology and learning",

  // Video links
  video1Title: "NDR Panorama 3",
  video1Description: "Interview about screen use and children",
  video1Url:
    "https://www.ndr.de/fernsehen/sendungen/panorama3/Panorama-3,sendung1549306.html",

  video2Title: "SRF Puls",
  video2Description:
    "Glücksfresser Smartphone - Do young people only need prohibitions?",
  video2Url:
    "https://www.srf.ch/play/tv/puls/video/gluecksfresser-smartphone---helfen-jugendlichen-nur-noch-verbote?urn=urn:srf:video:718034d7-11d4-4736-abad-358e32ee2328",

  video3Title: "YouTube Interview 1",
  video3Description: "Interview about technology and children's development",
  video3Url: "https://www.youtube.com/watch?v=hcYaQf9NnI8",

  video4Title: "YouTube Interview 2",
  video4Description: "Interview about screen time and ADHD",
  video4Url: "https://www.youtube.com/watch?v=vH6_xXifMSc",

  video5Title: "CyberSundhed - Boundaries give children security",
  video5Description: "Digital health and children",
  video5Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  video6Title:
    "BH Futures Foundation – Concentration and focus in the digital age",
  video6Description: "Concentration and focus in the digital age",
  video6Url: "https://www.youtube.com/watch?v=oO9pr9MOzXY",

  video7Title: "TV2 Fyn",
  video7Description: "Screen researcher is unwavering when his daughter cries",
  video7Url: "https://www.facebook.com/watch/?v=1261850819059739",

  video8Title: "Go' morgen Danmark & Go' aften Live",
  video8Description: "Screen time robs children of their creativity",
  video8Url: "https://www.facebook.com/watch/?v=1159225205443624",

  video9Title: "Headspace",
  video9Description: "Digital parenting strategies",
  video9Url: "https://www.facebook.com/watch/?v=1064828598575157",

  video10Title: "Headspace",
  video10Description: "Screen time guidelines for families",
  video10Url: "https://www.facebook.com/watch/?v=1092654535612773",

  video11Title: "BHRT Radiotelevizija Bosne I Hercegovine",
  video11Description: "Digital detoxification",
  video11Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  video12Title: "FACE HD TV",
  video12Description: "Concentration in digital age",
  video12Url: "https://www.youtube.com/watch?v=52YMLkfUQvQ",

  video13Title: "ALFA TV HD",
  video13Description: "Parenting in digital world",
  video13Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY",

  video14Title: "PSYCHOLOGOS Podcast",
  video14Description: "Children's mental health and screens",
  video14Url: "https://www.youtube.com/watch?v=OZd7SrqAwhY",

  video15Title: "Zonen (7 days without social media changed my life)",
  video15Description: "Digital literacy for families",
  video15Url: "https://www.youtube.com/watch?v=tXfJsYRKeR4",

  video16Title: "WDR Local Time",
  video16Description: "Children and their digital world",
  video16Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/kinder-und-ihre-digitale-welt-100.html",

  video17Title: "TV2 News",
  video17Description: "Screen time research findings",
  video17Url: "https://www.youtube.com/watch?v=9Bm7BjFYL4Q",

  video18Title: "DR Ultra",
  video18Description: "Technology and child development",
  video18Url: "https://www.youtube.com/watch?v=mF08O2mL7zY",

  video19Title: "TV2 Fyn",
  video19Description: "Mobile-free when the screen goes black",
  video19Url:
    "https://play.tv2.dk/serie/mobilfri-naar-skaermen-gaar-i-sort-tv2fyn",

  video20Title: "DR Ultra",
  video20Description: "Fake or fact - rabbits jumping on trampoline",
  video20Url:
    "https://www.dr.dk/drtv/se/ultra-nyt_-fake-eller-fakta_-kaniner-hopper-paa-trampolin_533209",

  // Podcast translations
  podcast1Title: "Do you watch too much screen?",
  podcast1Description: "Kraniebrud podcast about screen use",
  podcast1Url: "https://radio4.dk/podcasts/kraniebrud/ser-du-for-meget-sk-rm",

  podcast2Title: "Spotify Podcast",
  podcast2Description:
    "Spirende Sind: En Børne- og ungdomsppsykiatrisk podcast",
  podcast2Url: "https://open.spotify.com/episode/7stFudvRMPXrW5clAcxCYm",

  podcast3Title: "CyberSundhed",
  podcast3Description: "Aida Bikic on CyberSundhed podcast",
  podcast3Url:
    "https://creators.spotify.com/pod/profile/cybersundhed/episodes/--Aida-Bikic--CyberSundhed-e2k6mev",

  podcast4Title: "YouTube Interview",
  podcast4Description: "Digital health and children",
  podcast4Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  podcast5Title: "Spotify Episode",
  podcast5Description: "Interview with Signe",
  podcast5Url: "https://open.spotify.com/episode/0uTamNr0fQvP7aygp4zyTz",

  podcast6Title: "Brainstorm Podcast",
  podcast6Description: "Why do I have such a hard time putting my phone away?",
  podcast6Url:
    "https://podcasts.apple.com/ga/podcast/hvorfor-har-jeg-s%C3%A5-sv%C3%A6rt-ved-at-l%C3%A6gge-min-mobil-v%C3%A6k/id1449966468?i=1000671757018",

  watchButton: "Watch video",
  learnMoreButton: "Learn more",
};

export const HomeResourcesDE = {
  heroTitle: "Aida Bikic",
  heroNameTitle: "Psychologin, Forscherin und Referentin",
  heroSubtitle:
    "Zwischen Fokus und Ablenkung: Kinder, Jugendliche und ihre Bildschirmwelt",
  heroDescription: "Gesunde digitale Rahmen für Kinder und Jugendliche",
  heroExpertise: "Wie Bildschirme Aufmerksamkeit und ADHD beeinflussen",
  cta: "Mehr erfahren",
  s1Title: "Eltern & Wohlbefinden",
  s1Text:
    "Wissen und Werkzeuge für den Alltag mit Bildschirmen und sozialen Medien.",
  s2Title: "Schulen & Lernen",
  s2Text:
    "Vorträge und Kurse über Aufmerksamkeit, Lernen und digitale Bildung.",
  s3Title: "Forschung & Medien",
  s3Text:
    "Vermittlung von Wissen über die Auswirkungen von Technologie auf kindliche Gehirne.",
  videosTitle: "Dokumentationen",
  videosIntro: "Sehen Sie Aida in verschiedenen Medien und Interviews",
  podcastsTitle: "Podcasts",
  podcastsIntro:
    "Hören Sie Aida in Podcasts über Kinder, Technologie und Lernen",

  // Video links
  video1Title: "NDR Panorama 3",
  video1Description: "Interview über Bildschirmnutzung und Kinder",
  video1Url:
    "https://www.ndr.de/fernsehen/sendungen/panorama3/Panorama-3,sendung1549306.html",

  video2Title: "SRF Puls",
  video2Description:
    "Glücksfresser Smartphone - Brauchen Jugendliche nur noch Verbote?",
  video2Url:
    "https://www.srf.ch/play/tv/puls/video/gluecksfresser-smartphone---helfen-jugendlichen-nur-noch-verbote?urn=urn:srf:video:718034d7-11d4-4736-abad-358e32ee2328",

  video3Title: "YouTube Interview 1",
  video3Description: "Interview über Technologie und kindliche Entwicklung",
  video3Url: "https://www.youtube.com/watch?v=hcYaQf9NnI8",

  video4Title: "YouTube Interview 2",
  video4Description: "Interview über Bildschirmzeit und ADHS",
  video4Url: "https://www.youtube.com/watch?v=vH6_xXifMSc",

  video5Title: "CyberSundhed - Boundaries give children security",
  video5Description: "Digitale Gesundheit und Kinder",
  video5Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  video6Title:
    "BH Futures Foundation – Konzentration und Fokus im digitalen Zeitalter",
  video6Description: "Konzentration und Fokus im digitalen Zeitalter",
  video6Url: "https://www.youtube.com/watch?v=oO9pr9MOzXY",

  video7Title: "TV2 Fyn",
  video7Description:
    "Bildschirmforscher ist unerschütterlich, wenn seine Tochter weint",
  video7Url: "https://www.facebook.com/watch/?v=1261850819059739",

  video8Title: "Go' morgen Danmark & Go' aften Live",
  video8Description: "Bildschirmzeit raubt Kindern ihre Kreativität",
  video8Url: "https://www.facebook.com/watch/?v=1159225205443624",

  video9Title: "Headspace",
  video9Description: "Digitale Erziehungsstrategien",
  video9Url: "https://www.facebook.com/watch/?v=1064828598575157",

  video10Title: "Headspace",
  video10Description: "Bildschirmzeit-Richtlinien für Familien",
  video10Url: "https://www.facebook.com/watch/?v=1092654535612773",

  video11Title: "BHRT Radiotelevizija Bosne I Hercegovine",
  video11Description: "Digitale Entgiftung",
  video11Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  video12Title: "FACE HD TV",
  video12Description: "Konzentration im digitalen Zeitalter",
  video12Url: "https://www.youtube.com/watch?v=52YMLkfUQvQ",

  video13Title: "ALFA TV HD",
  video13Description: "Erziehung in der digitalen Welt",
  video13Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY",

  video14Title: "PSYCHOLOGOS Podcast",
  video14Description: "Kinderpsychische Gesundheit und Bildschirme",
  video14Url: "https://www.youtube.com/watch?v=OZd7SrqAwhY",

  video15Title: "Zonen (7 Tage ohne soziale Medien veränderten mein Leben)",
  video15Description: "Digitale Kompetenz für Familien",
  video15Url: "https://www.youtube.com/watch?v=tXfJsYRKeR4",

  video16Title: "WDR Local Time",
  video16Description: "Kinder und ihre digitale Welt",
  video16Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/kinder-und-ihre-digitale-welt-100.html",

  video17Title: "TV2 News",
  video17Description: "Bildschirmzeit-Forschungsergebnisse",
  video17Url: "https://www.youtube.com/watch?v=9Bm7BjFYL4Q",

  video18Title: "DR Ultra",
  video18Description: "Technologie und kindliche Entwicklung",
  video18Url: "https://www.youtube.com/watch?v=mF08O2mL7zY",

  video19Title: "TV2 Fyn",
  video19Description: "Mobilfrei wenn der Bildschirm schwarz wird",
  video19Url:
    "https://play.tv2.dk/serie/mobilfri-naar-skaermen-gaar-i-sort-tv2fyn",

  video20Title: "DR Ultra",
  video20Description: "Fake oder Fakt - Kaninchen springen auf Trampolin",
  video20Url:
    "https://www.dr.dk/drtv/se/ultra-nyt_-fake-eller-fakta_-kaniner-hopper-paa-trampolin_533209",

  // Podcast translations
  podcast1Title: "Siehst du zu viel Bildschirm?",
  podcast1Description: "Kraniebrud Podcast über Bildschirmnutzung",
  podcast1Url: "https://radio4.dk/podcasts/kraniebrud/ser-du-for-meget-sk-rm",

  podcast2Title: "Spotify Podcast",
  podcast2Description:
    "Spirende Sind: En Børne- og ungdomsppsykiatrisk podcast",
  podcast2Url: "https://open.spotify.com/episode/7stFudvRMPXrW5clAcxCYm",

  podcast3Title: "CyberSundhed",
  podcast3Description: "Aida Bikic im CyberSundhed Podcast",
  podcast3Url:
    "https://creators.spotify.com/pod/profile/cybersundhed/episodes/--Aida-Bikic--CyberSundhed-e2k6mev",

  podcast4Title: "YouTube Interview",
  podcast4Description: "Digitale Gesundheit und Kinder",
  podcast4Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  podcast5Title: "Spotify Episode",
  podcast5Description: "Interview mit Signe",
  podcast5Url: "https://open.spotify.com/episode/0uTamNr0fQvP7aygp4zyTz",

  podcast6Title: "Brainstorm Podcast",
  podcast6Description: "Warum fällt es mir so schwer, mein Handy wegzulegen?",
  podcast6Url:
    "https://podcasts.apple.com/ga/podcast/hvorfor-har-jeg-s%C3%A5-sv%C3%A6rt-ved-at-l%C3%A6gge-min-mobil-v%C3%A6k/id1449966468?i=1000671757018",

  watchButton: "Video ansehen",
  learnMoreButton: "Mehr erfahren",
};

export const HomeResourcesBS = {
  heroTitle: "Aida Bikic",
  heroNameTitle: "Psiholog, istraživač i predavač",
  heroSubtitle:
    "Kako ekrani utiču na koncentraciju i razvoj kod djece i mladih",
  heroDescription: "Zdravi digitalni okviri za djecu i mlade",
  heroExpertise: "Znanje i alati za ADHD u digitalnom dobu",
  cta: "Saznaj više",
  s1Title: "Roditelji & dobrobit",
  s1Text:
    "Znanje i alati za svakodnevni život s ekranima i društvenim mrežama.",
  s2Title: "Škole & učenje",
  s2Text: "Predavanja i tečajevi o pažnji, učenju i digitalnoj pismenosti.",
  s3Title: "Istraživanje & mediji",
  s3Text: "Prenos znanja o utjecaju tehnologije na dječji mozak.",
  videosTitle: "Dokumentarci",
  videosIntro: "Pogledajte Aidu u različitim medijima i intervjuima",
  podcastsTitle: "Podcast",
  podcastsIntro: "Slušajte Aidu u podcastovima o djeci, tehnologiji i učenju",

  // Video links
  video1Title: "NDR Panorama 3",
  video1Description: "Intervju o korištenju ekrana i djeci",
  video1Url:
    "https://www.ndr.de/fernsehen/sendungen/panorama3/Panorama-3,sendung1549306.html",

  video2Title: "SRF Puls",
  video2Description:
    "Glücksfresser Smartphone - Da li mladima trebaju samo zabrane?",
  video2Url:
    "https://www.srf.ch/play/tv/puls/video/gluecksfresser-smartphone---helfen-jugendlichen-nur-noch-verbote?urn=urn:srf:video:718034d7-11d4-4736-abad-358e32ee2328",

  video3Title: "YouTube Interview 1",
  video3Description: "Intervju o tehnologiji i razvoju djece",
  video3Url: "https://www.youtube.com/watch?v=hcYaQf9NnI8",

  video4Title: "YouTube Interview 2",
  video4Description: "Intervju o vremenu pred ekranom i ADHD-u",
  video4Url: "https://www.youtube.com/watch?v=vH6_xXifMSc",

  video5Title: "CyberSundhed - Boundaries give children security",
  video5Description: "Digitalno zdravlje i djeca",
  video5Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  video6Title:
    "BH Futures Foundation – Koncentracija i fokus u digitalnom dobu",
  video6Description: "Koncentracija i fokus u digitalnom dobu",
  video6Url: "https://www.youtube.com/watch?v=oO9pr9MOzXY",

  video7Title: "TV2 Fyn",
  video7Description:
    "Istraživač ekrana je nepokolebljiv kada njegova kći plače",
  video7Url: "https://www.facebook.com/watch/?v=1261850819059739",

  video8Title: "Go' morgen Danmark & Go' aften Live",
  video8Description: "Vrijeme pred ekranom krade djeci njihovu kreativnost",
  video8Url: "https://www.facebook.com/watch/?v=1159225205443624",

  video9Title: "Headspace",
  video9Description: "Digitalne strategije roditeljstva",
  video9Url: "https://www.facebook.com/watch/?v=1064828598575157",

  video10Title: "Headspace",
  video10Description: "Smjernice za vrijeme pred ekranom za obitelji",
  video10Url: "https://www.facebook.com/watch/?v=1092654535612773",

  video11Title: "BHRT Radiotelevizija Bosne I Hercegovine",
  video11Description: "Digitalna detoksikacija",
  video11Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  video12Title: "FACE HD TV",
  video12Description: "Koncentracija u digitalnom dobu",
  video12Url: "https://www.youtube.com/watch?v=52YMLkfUQvQ",

  video13Title: "ALFA TV HD",
  video13Description: "Roditeljstvo u digitalnom svijetu",
  video13Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY",

  video14Title: "PSYCHOLOGOS Podcast",
  video14Description: "Mentalno zdravlje djece i ekrani",
  video14Url: "https://www.youtube.com/watch?v=OZd7SrqAwhY",

  video15Title: "Zona (7 dana bez društvenih mreža promijenilo je moj život)",
  video15Description: "Digitalna pismenost za obitelji",
  video15Url: "https://www.youtube.com/watch?v=tXfJsYRKeR4",

  video16Title: "WDR Local Time",
  video16Description: "Djeca i njihov digitalni svijet",
  video16Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/kinder-und-ihre-digitale-welt-100.html",

  video17Title: "TV2 News",
  video17Description: "Rezultati istraživanja vremena pred ekranom",
  video17Url: "https://www.youtube.com/watch?v=9Bm7BjFYL4Q",

  video18Title: "DR Ultra",
  video18Description: "Tehnologija i razvoj djece",
  video18Url: "https://www.youtube.com/watch?v=mF08O2mL7zY",

  video19Title: "TV2 Fyn",
  video19Description: "Bez mobilnog kada ekran postane crn",
  video19Url:
    "https://play.tv2.dk/serie/mobilfri-naar-skaermen-gaar-i-sort-tv2fyn",

  video20Title: "DR Ultra",
  video20Description: "Laž ili činjenica - zečevi skaču na trampolinu",
  video20Url:
    "https://www.dr.dk/drtv/se/ultra-nyt_-fake-eller-fakta_-kaniner-hopper-paa-trampolin_533209",

  // Podcast translations
  podcast1Title: "Da li gledate previše ekrana?",
  podcast1Description: "Kraniebrud podcast o korištenju ekrana",
  podcast1Url: "https://radio4.dk/podcasts/kraniebrud/ser-du-for-meget-sk-rm",

  podcast2Title: "Spotify Podcast",
  podcast2Description:
    "Spirende Sind: En Børne- og ungdomsppsykiatrisk podcast",
  podcast2Url: "https://open.spotify.com/episode/7stFudvRMPXrW5clAcxCYm",

  podcast3Title: "CyberSundhed",
  podcast3Description: "Aida Bikic u CyberSundhed podcastu",
  podcast3Url:
    "https://creators.spotify.com/pod/profile/cybersundhed/episodes/--Aida-Bikic--CyberSundhed-e2k6mev",

  podcast4Title: "YouTube Interview",
  podcast4Description: "Digitalno zdravlje i djeca",
  podcast4Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  podcast5Title: "Spotify Episode",
  podcast5Description: "Intervju sa Signe",
  podcast5Url: "https://open.spotify.com/episode/0uTamNr0fQvP7aygp4zyTz",

  podcast6Title: "Brainstorm Podcast",
  podcast6Description: "Zašto mi je tako teško da odložim telefon?",
  podcast6Url:
    "https://podcasts.apple.com/ga/podcast/hvorfor-har-jeg-s%C3%A5-sv%C3%A6rt-ved-at-l%C3%A6gge-min-mobil-v%C3%A6k/id1449966468?i=1000671757018",

  watchButton: "Pogledaj video",
  learnMoreButton: "Saznaj više",
};
